import React from 'react';
import { useTheme } from 'styled-components';
import useBreakpoint from 'Common/hooks/useBreakpoint';

import { Calendar, Clock } from '@solent-university/solent-icons';

import { Props as LinkProps } from 'Elements/Link';

import {
    Container,
    Data,
    BookLink,
    DataContainer,
    LinkWrapper,
    IconWrapper,
    Icon
} from './Booking.styled';

export interface Props {
    courseRef: string;
    date: string;
    time: string;
    venue: string;
    link: LinkProps;
    id: string;
}

const Booking: React.FC<Props> = props => {
    const { courseRef, date, time, venue, link } = props;
    const { breakpoints } = useTheme();
    const isMediumBreakpoint = useBreakpoint(breakpoints.medium.value);

    return (
        <>
            {isMediumBreakpoint ? (
                <Container>
                    <Data>{courseRef}</Data>
                    <Data>{date}</Data>
                    <Data>{time}</Data>
                    <Data>{venue}</Data>
                    <BookLink {...link} />
                </Container>
            ) : (
                <Container>
                    <DataContainer>
                        <Data>{courseRef}</Data>
                        <Data>{venue}</Data>
                        <IconWrapper>
                            <Icon as={Calendar} />
                            <Data>{date}</Data>
                        </IconWrapper>
                        <IconWrapper>
                            <Icon as={Clock} />
                            <Data>{time}</Data>
                        </IconWrapper>
                    </DataContainer>
                    <LinkWrapper>
                        <BookLink {...link} />
                    </LinkWrapper>
                </Container>
            )}
        </>
    );
};

export default Booking;
